export const defs = {
	apiVersion: 0.9,
	contentType: 'application/json',
	userId: 'userId',
	authToken: 'token',
	activationToken: 'activationToken',
	populationFilter: 'populationQueryParams',
	mySwarmFilter: 'swarmQueryParams',
	exchangeFilter: 'exchangeQueryParams',
	crisprFilter: 'crisprQueryParams',
	previousUrl: 'previousUrl',
	dayToMinutes: 1440,
	sortOrders: {
		population: {
			like: 'desc',
			productivity: 'desc',
			age: 'asc',
			fitness: 'desc',
			price: 'asc'
		},
		mySwarm: {
			like: 'desc',
			productivity: 'desc',
			age: 'asc',
			fitness: 'desc',
			price: 'asc'
		},
		crispr: {
			price: 'asc',
			like: 'desc',
			fitness: 'desc',
			productivity: 'desc'
		},
		exchange: {
			glitterAmount: 'desc',
			price: 'asc',
			like: 'desc'
		},
		defaults: {
			population: 'age',
			mySwarm: 'age',
			crispr: 'price',
			exchange: 'price'
		}
	},
	// DecimalPipe configuration (https://angular.io/api/common/DecimalPipe)
	digitsInfo: {
		eth: '1.0-4',
		usd: '1.0-1',
		gtr: '1.0-0'
	},
	colorPalette: {
		skin: [
			'hue-rotate(76deg) saturate(48%) brightness(119%)',
			'hue-rotate(119deg) saturate(130%) brightness(89%)',
			'hue-rotate(143deg) saturate(57%) brightness(75%)',
			'hue-rotate(117deg) saturate(43%) brightness(40%)',
			'hue-rotate(60deg) saturate(50%) brightness(30%)',
			'hue-rotate(91deg) saturate(900%) brightness(50%)',
			'hue-rotate(110deg) saturate(300%) brightness(60%)',
			'hue-rotate(10deg) saturate(100%) brightness(50%)',
			'hue-rotate(-30deg) saturate(200%) brightness(120%)',
			'hue-rotate(-5deg) saturate(90%) brightness(90%)',
			'hue-rotate(70deg) saturate(700%) brightness(35%)',
			'hue-rotate(65deg) saturate(300%) brightness(70%)',
			'hue-rotate(185deg) saturate(220%) brightness(77%)',
			'hue-rotate(-56deg) saturate(130%) brightness(90%)',
			'hue-rotate(50deg) saturate(130%) brightness(105%)' ],
		belly: [
			'hue-rotate(175deg) saturate(43%) brightness(48%)',
			'hue-rotate(181deg) saturate(54%) brightness(75%)',
			'hue-rotate(213deg) saturate(200%) brightness(80%)',
			'hue-rotate(200deg) saturate(500%) brightness(100%)',
			'hue-rotate(185deg) saturate(600%) brightness(95%)',
			'hue-rotate(215deg) saturate(400%) brightness(80%)',
			'hue-rotate(210deg) saturate(220%) brightness(40%)',
			'hue-rotate(200deg) saturate(900%) brightness(90%)',
			'hue-rotate(245deg) saturate(200%) brightness(90%)',
			'hue-rotate(215deg) saturate(500%) brightness(85%)',
			'hue-rotate(-80deg) saturate(80%) brightness(50%)',
			'hue-rotate(-95deg) saturate(230%) brightness(100%)',
			'hue-rotate(-95deg) saturate(230%) brightness(150%)',
			'hue-rotate(110deg) saturate(170%) brightness(105%)',
			'hue-rotate(60deg) saturate(300%) brightness(89%)' ],
		hair: [
			'hue-rotate(0deg) saturate(14%) brightness(44%)',
			'hue-rotate(61deg) saturate(12%) brightness(103%)',
			'hue-rotate(15deg) saturate(11%) brightness(35%)',
			'hue-rotate(20deg) saturate(30%) brightness(180%)',
			'hue-rotate(-10deg) saturate(90%) brightness(70%)',
			'hue-rotate(-10deg) saturate(36%) brightness(130%)',
			'hue-rotate(-30deg) saturate(100%) brightness(250%)',
			'hue-rotate(30deg) saturate(100%) brightness(180%)',
			'hue-rotate(20deg) saturate(30%) brightness(180%)',
			'hue-rotate(30deg) saturate(60%) brightness(70%)',
			'hue-rotate(300deg) saturate(80%) brightness(50%)',
			'hue-rotate(288deg) saturate(11%) brightness(90%)',
			'hue-rotate(210deg) saturate(50%) brightness(170%)',
			'hue-rotate(0deg) saturate(70%) brightness(110%)',
			'hue-rotate(32deg) saturate(50%) brightness(100%)',
			'hue-rotate(258deg) saturate(19%) brightness(150%)',
			'hue-rotate(231deg) saturate(45%) brightness(55%)'],
		pattern: [
			'hue-rotate(0deg) saturate(0%) brightness(500%)',
			'hue-rotate(174deg) saturate(76%) brightness(120%)',
			'hue-rotate(173deg) saturate(65%) brightness(66%)',
			'hue-rotate(180deg) saturate(40%) brightness(200%)',
			'hue-rotate(240deg) saturate(40%) brightness(300%)',
			'hue-rotate(245deg) saturate(20%) brightness(250%)',
			'hue-rotate(209deg) saturate(30%) brightness(55%)',
			'hue-rotate(160deg) saturate(20%) brightness(120%',
			'hue-rotate(80deg) saturate(30%) brightness(200%)',
			'hue-rotate(80deg) saturate(30%) brightness(300%)',
			'hue-rotate(355deg) saturate(60%) brightness(70%)',
			'hue-rotate(78deg) saturate(48%) brightness(350%)',
			'hue-rotate(178deg) saturate(43%) brightness(270%)',
			'hue-rotate(195deg) saturate(53%) brightness(100%)',
			'hue-rotate(50deg) saturate(60%) brightness(300%)',
			'hue-rotate(187deg) saturate(36%) brightness(50%)',
			'hue-rotate(35deg) saturate(40%) brightness(470%)',
			'hue-rotate(300deg) saturate(5%) brightness(300%)',
			'hue-rotate(40deg) saturate(70%) brightness(500%)' ],
		eye: [
			'hue-rotate(208deg) saturate(60%) brightness(100%)',
			'hue-rotate(270deg) saturate(40%) brightness(100%)',
			'hue-rotate(344deg) saturate(30%) brightness(150%)',
			'hue-rotate(60deg) saturate(30%) brightness(250%)',
			'hue-rotate(166deg) saturate(20%) brightness(230%)',
			'hue-rotate(195deg) saturate(60%) brightness(100%)',
			'hue-rotate(316deg) saturate(10%) brightness(170%)',
			'hue-rotate(320deg) saturate(98%) brightness(100%)',
			'hue-rotate(60deg) saturate(75%) brightness(210%)',
			'hue-rotate(90deg) saturate(70%) brightness(150%)',
			'hue-rotate(73deg) saturate(150%) brightness(250%)',
			'hue-rotate(313deg) saturate(10%) brightness(313%)',
			'hue-rotate(50deg) saturate(20%) brightness(250%)',
			'hue-rotate(50deg) saturate(50%) brightness(130%)',
			'hue-rotate(0deg) saturate(0%) brightness(100%)' ]
	},
	social: {
		facebook: 'https://www.facebook.com/narwhaliaNFT',
		instagram: 'https://www.instagram.com/narwhaliaNFT',
		twitter: 'https://twitter.com/narwhaliaNFT',
		youtube: 'https://www.youtube.com/channel/UC9rkVqYEuCxtoH5RMj0rbQw'
	}
}

export * from './bo/digitsInfo'